import { memo } from "react";
import type { OptionRow, RenderOptionContent } from "../types";
import ListItem from "components/primitives/ListItem";
import { styled } from "@mui/material";

const ListItemOption = styled(ListItem)(() => ({
  boxSizing: "border-box",
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
}));

interface ListboxOptionProps {
  row: OptionRow;
  /** Virtual row index, which the virtualizer measures rows by. */
  index: number;
  /** Offset the virtualizer placed this row at, in px. */
  start: number;
  measureElement?: (node: Element | null) => void;
  renderContent: RenderOptionContent<unknown>;
}

/** One option of the listbox, placed at the offset the virtualizer gave it. */
function ListboxOption({ row, index, start, measureElement, renderContent }: ListboxOptionProps) {
  const [optionProps, option, state] = row.tuple;
  const { key, ...htmlProps } = optionProps;

  return (
    <ListItemOption
      {...htmlProps}
      aria-posinset={row.positionInSet}
      aria-setsize={row.setSize}
      ref={measureElement}
      data-index={index}
      style={{ transform: `translateY(${start}px)` }}
    >
      {renderContent(option, row.optionIndex, state)}
    </ListItemOption>
  );
}

export default memo(ListboxOption);
